import { combineEpics } from 'redux-observable';

import { canvasEpics } from '../canvas/common/epics';
import { html5Epics } from '../canvas/Html5App/epics';
import { videoCreatorEpics } from '../video-creator/common/epics';

import { updateGridBannerPriceCellEpic } from './banners-grid';
import { resetBannersPricesEpic, saveBannersPricesEpic, validateBannersPricesEpic } from './banners-prices';
import { bannersEditEpic } from './bannersEdit/bannersEdit';
import {
    onAcceptMassActionsCalloutsEditorEpic,
    onAcceptMassActionsImageEditorEpic,
    onAcceptMassActionSiteLinksDataEpic,
    onAcceptMassActionsLinkBulkPathReplacementEditorEpic,
    onAcceptMassActionsLinkBulkReplacementEditorEpic,
    onAcceptMassActionsLinkDisplayedBulkReplacementEditorEpic,
    onAcceptMassActionsVideoEditorEpic,
    onSaveMassActionsTextBulkReplacementEditorEpic
} from './bannersEdit/bannersEditMassAction/bannersEditMassAction';
import { clearInternalBannerEpic } from './bannersEdit/internal/clearInternalBannerEpic';
import { duplicateInternalBannerEpic } from './bannersEdit/internal/duplicateInternalBannerEpic';
import { openInternalBannersEditEpic } from './bannersEdit/internal/openInternalBannersEditEpic';
import { saveInternalBannerNameEditorChangesEpic } from './bannersEdit/internal/saveInternalBannerNameEditorChangesEpic';
import { saveInternalBannersEpic } from './bannersEdit/internal/saveInternalBannersEpic';
import { scrollToDuplicateInternalBannerEpic } from './bannersEdit/internal/scrollToDuplicateInternalBannerEpic';
import { scrollToNewInternalBannerEpic } from './bannersEdit/internal/scrollToNewInternalBannerEpic';
import { updateInternalBannerTemplateIdEpic } from './bannersEdit/internal/updateInternalBannerTemplateIdEpic';
import { loadBannersPreviewEpic } from './bannersPreview/bannersPreview';
import { AddCalloutsEpic, RemoveCalloutsEpic } from './callouts/callouts';
import {
    acceptCampaignAndGroupSelectorDataDnaEpic,
    acceptCampaignAndGroupSelectorDataEpic,
    fetchCampaignAndGroupSelectorCampaignsDataEpic,
    fetchCampaignAndGroupSelectorGroupsDataEpic,
    openCampaignAndGroupSelectorEpic,
    selectCampaignAndGroupSelectorCampaignEpic,
    startAddEntityFromMenuEpic
} from './campaignAndGroupSelector';
import { updateCampaignDayBudgetEpic } from './campaigns-grid';
import { campaignsEditEpic } from './campaignsEdit/campaignsEdit';
import { chatListEditorEpic } from './chatListEditor/chatListEditor';
import { requestClientFreelancerDataEpic } from './clientFreelancerData';
import { requestClientMobileAppsDataEpic } from './clientMobileApps';
import {
    changeGoalsCheckedFromColumnsSettingsEditorEpic,
    columnsSettingsEditorEpic,
    openColumnsSettingsEditorEpic
} from './columnsSettingsEditor/columnsSettingsEditor';
import {
    changeLocationHardDataEpic,
    commonDataEpic,
    deleteCookieEpic,
    fetchTimeZoneGroupsEpic,
    hideRecommendationTooltipEpic,
    onGridSourceParamsChangedEpic,
    redirectToLocationEpic,
    rejectRequestAuthorizationDataEpic,
    reloadLocationEpic,
    requestAuthorizationData,
    setCookieEpic,
    updateDocumentTitleEpic
} from './common';
import { onDeleteEndDateForDatesIntervalEditorEpic } from './datesIntervalEditor/datesIntervalEditor';
import {
    acceptRejectDealsEpic,
    clientsDealsLoadEpic,
    dealDetailEpic,
    loadDealsCampaignsEpic,
    requestDealsEpic,
    resetDealsDataEpic,
    updateDealsEpic,
    updateDealsSourceParamsEpic
} from './deals/deals';
import { dealsHelpersEpic } from './deals/deals-helpers';
import { dealsNavigationEpic } from './deals/deals-navigation';
import {
    doFakeAuthEpic,
    fetchClientDev,
    switchDumpVarsStateEpic,
    switchShowCaptchaStateEpic
} from './development-tools';
import {
    saveFeedFilterPriorityCellEpic,
    saveFeedFilterRateCellEpic,
    saveFeedFiltersAutobudgetPriorityEpic,
    saveFeedFiltersRateEpic,
    setInitialFeedFilterPriorityEpic,
    setInitialFeedFilterRateEpic
} from './feed-filters-grid';
import { freelancers } from './freelancers';
import { fetchGoalsDataEpic } from './goals/goals';
import { gridScreenEpic } from './grid-screen/grid-screen';
import { gridScreenHelpersEpic } from './grid-screen/grid-screen-helpers/grid-screen-helpers';
import { gridScreenMassActionsEpic } from './grid-screen/grid-screen-mass-actions';
import { gridScreenNavigationEpic } from './grid-screen/grid-screen-navigation';
import {
    addSmartFilterEpic,
    deleteSmartFilterEpic,
    getGroupFiltersEpic,
    updateSmartFilterEpic,
    updateSmartFilterSuccessEpic
} from './groupFilters/groupFilters';
import {
    acceptDuplicateGroupsItemsEpic,
    changeDuplicateGroupsModalViewStateEpic,
    fetchDuplicateGroupsCampaignSelectorDataItemsEpic
} from './groupsDuplicateSelector/groupsDuplicateSelector';
import { groupsEditEpic } from './groupsEdit/groupsEdit';
import { onAcceptMinusPhraseGroupsMassActionsEpic } from './groupsEdit/massActions/massActions';
import {
    fetchHeaderInfoEpic,
    fetchHeaderWalletInfoEpic,
    fetchInfoBlockDataEpic,
    fetchInfoBlockNewsItemEpic,
    fetchUserAccountsInfoEpic,
    sendFeedbackEpic
} from './header/header';
import { openImageInternalGalleryEpic } from './imageEditor/internal/openImageInternalGalleryEpic';
import { removeInternalBannerImageEpic } from './imageEditor/internal/removeInternalBannerImageEpic';
import { updateInternalBannerImageByGalleryEpic } from './imageEditor/internal/updateInternalBannerImageByGalleryEpic';
import { uploadInternalBannerImageByLinkEpic } from './imageEditor/internal/uploadInternalBannerImageByLinkEpic';
import { uploadInternalBannerImageEpic } from './imageEditor/internal/uploadInternalBannerImageEpic';
import {
    openImageSmartCenterEditorEpic,
    saveImageSmartCentersEpic,
    updateImagesSmartCentresEpic
} from './imageSmartCenterEditor/imageSmartCenterEditor';
import { saveImportExportWizardEpic } from './importExportWizard/saveImportExportWizard';
import { updateImportExportWizardVisibilityEpic } from './importExportWizard/updateImportExportWizardVisibility';
import { saveImportSourceFilesEpic } from './importWizard/saveImportSourceFiles';
import { saveImportWizardEpic } from './importWizard/saveImportWizard';
import { saveImportWizardSuccessEpic } from './importWizard/saveImportWizardSuccess';
import { showUploadFileImportWizardRequestErrorEpic } from './importWizard/showUploadFileImportWizardRequestError';
import { uploadFileImportWizardEpic } from './importWizard/uploadFileImportWizard';
import { uploadImagesImportWizardEpic } from './importWizard/uploadImagesImportWizard';
import { loadMobileInstalledAppsDataEpic, saveInternalGroupsEpic } from './internalGroups';
import { keywordsEditorEpic } from './keywordsEditor';
import { logEpics } from './log';
import { logHelpers } from './log-helpers';
import { logNavigationEpic } from './log-navigation';
import { addInternalMarketerProductAccessEpic } from './marketer/internal/addInternalMarketerProductAccessEpic/addInternalMarketerProductAccessEpic';
import { loadInternalMarketerEpic } from './marketer/internal/loadInternalMarketerEpic';
import { removeInternalMarketerProductAccessEpic } from './marketer/internal/removeInternalMarketerProductAccessEpic/removeInternalMarketerProductAccessEpic';
import { updateInternalMarketerProductAccessEpic } from './marketer/internal/updateInternalMarketerProductAccessEpic/updateInternalMarketerProductAccessEpic';
import { filterInternalMarketersEpic } from './marketers/internal/filterInternalMarketersEpic';
import { loadInternalMarketersEpic } from './marketers/internal/loadInternalMarketersEpic';
import { metrikaCounterEditorEpic } from './metrikaCounterEditor/metrikaCounterEditor';
import {
    createMinusPhraseListDataEpic,
    deleteMinusPhraseListEpic,
    handleMinusPhraseLibraryColumnsWidthUpdateEpic,
    openMinusPhraseLibraryAddListModalEpic,
    openMinusPhraseLibraryEditListModalEpic,
    requestMinusPhraseLibraryGridRowEpic,
    resetMinusPhraseLibraryEpic,
    updateMinusPhraseListDataEpic
} from './minusPhraseLibrary/minusPhraseLibrary';
import {
    addLibraryListEditorEpic,
    fetchLibraryListsEpic,
    openEditorMinusPhraseLibraryEpic
} from './minusPhrasesEditor/minusPhrasesEditor';
import {
    createMobileAppEpic,
    fetchAppTrackersTemplatesEpic,
    fetchMobileAppEpic,
    fetchMobileAppStoreInfoEpic,
    fetchMobileAppTemplatesEpic,
    updateMobileAppEpic
} from './mobile-app';
import { fetchMobileAppsListEpic } from './mobile-apps-list';
import { organizationsEpics } from './organization/organization';
import { updatePhraseEpic } from './phrases-grid';
import {
    changeRefinePhraseEpic,
    generatePhrasesEpic,
    getGroupKeywordsEpic,
    getPhrasesStatsEpic,
    getPhraseStatsEpic,
    getRefinePhraseShowsEpic,
    getRefineWords,
    leavePhrasesSelectorEpic,
    manualInputSubmitEpic,
    openPhrasesSelectorEpic,
    savePhrasesEpic,
    updatePhrasesStatsEpic
} from './phrasesSelector/phrasesSelector';
import {
    addPhraseToStartPhrasesEpic,
    fetchPhrasesForPhrasesSelectorWizardEpic,
    openPhrasesSelectorWizardEpic,
    removeMinusPhraseEpic,
    sendMinusPhraseEpic,
    submitSelectionWizardEpic,
    submitStartPhraseInputValueEpic
} from './phrasesSelectorWizard/phrasesSelectorWizard';
import { fetchPredictorEpic, fetchPredictorMapEpic, fetchPredictorRecommendationEpic } from './predictor/predictor';
import {
    fetchPredictorEditor,
    initialPredictorIndoorEditor,
    initialPredictorOutdoorEditor
} from './predictorEditor/predictorEditor';
import {
    gridScreenGoToPackageEditEpic,
    leavePricePackageEditEpic,
    openPricePackagesClientsModalEpic,
    requestPricePackagesEpic,
    resetPricePackagesDataEpic,
    savePricePackagesClientsModalEpic,
    saveStatusPricePackageEpic,
    updatePricePackagesSourceParamsEpic
} from './pricePackages/pricePackages';
import { pricePackagesEditEpic } from './pricePackages/pricePackagesEdit';
import { pricePackagesHelpersEpic } from './pricePackages/pricePackagesHelper';
import { pricePackagesNavigationEpic } from './pricePackages/pricePackagesNavigation';
import { acceptPricesWizardChanges } from './prices-wizard';
import { createInternalProductEpic } from './products/internal/createInternalProductEpic/createInternalProductEpic';
import { loadInternalProductsEpic } from './products/internal/loadInternalProductsEpic';
import { updateInternalProductDescriptionEpic } from './products/internal/updateInternalProductDescriptionEpic/updateInternalProductDescriptionEpic';
import {
    fetchRecommendationsGridDataEpic,
    fetchRecommendationsGridSummaryEpic,
    getRecommendationsGridItemApplyStatusEpic,
    getRecommendationsGridSummaryApplyStatusEpic,
    submitRecommendationsGridDataItemEpic,
    submitRecommendationsGridSummaryEpic
} from './recommendations-grid/recommendations-grid';
import { recommendationsGridHelpersEpic } from './recommendations-grid/recommendations-grid-helpers';
import {
    fetchRecommendationsScreenDataEpic,
    getRecommendationApplyCardStatusEpic,
    submitRecommendationCardEpic
} from './recommendations/recommendations';
import { regionFetchSuggestListEpic } from './regions';
import { startChangeFilterTextRegionsEditorEpic } from './regionsEditor/regionsEditor';
import { changeSearchValueForRegionsSearchEditorEpic } from './regionsSearchEditor/regionsSearchEditor';
import {
    applyRegionsTransformEditorEpic,
    clearRegionsTransformEditorEpic,
    fetchTopRegionsForRegionsTransformEditorEpic,
    openRegionsTransformEditorEpic,
    showNotificationRegionsTransformEditorEpic
} from './regionsTransformEditor/regionsTransformEditor';
import { addReportEpic, fetchReportsDataEpic } from './reportsClient/reportsClient';
import { reportHelpersEpic } from './reportsClient/reportsClient-helpers';
import { addReportDomainEpic, fetchReportsDomainDataEpic } from './reportsDomain/reportsDomain';
import { reportDomainHelpersEpic } from './reportsDomain/reportsDomain-helpers';
import {
    acceptMassCommonPriceChangesEpic,
    changeCopiedRetargetingRulesTooltipStatusEpic,
    copyRetargetingRulesInfoToClipboardEpic,
    updateRetargetingCommonPriceCellEpic
} from './retargeting/retargeting';
import {
    changeVisitorForecastDataEpic,
    openRetargetingConditionEditorEpic,
    saveAudienceRetargetingConditionAsNewDataEpic,
    saveRetargetingConditionAsNewDataEpic,
    saveRetargetingConditionDataEpic
} from './retargetingConditionEditor/retargetingConditionEditor';
import {
    addRetargetingConditionEpic,
    deleteRetargetingListItemEpic,
    editRetargetingListItemEpic,
    updateRetargetingConditionEpic
} from './retargetingEditor/retargetingEditor';
import { routerLocationChangedEpic } from './router';
import { openTimeTargetingEditorEpic } from './timeTargetingEditor/timeTargetingEditor';
import { userSettingsEpic } from './userSettings';
import { visitingCardEditorEpic } from './visitingCardEditor';
import { welcomeDataEpic } from './welcome';

export const epics = [
    gridScreenEpic,
    welcomeDataEpic,
    bannersEditEpic,
    updateImportExportWizardVisibilityEpic,
    saveImportExportWizardEpic,
    saveImportWizardEpic,
    saveImportWizardSuccessEpic,
    uploadFileImportWizardEpic,
    saveImportSourceFilesEpic,
    showUploadFileImportWizardRequestErrorEpic,
    uploadImagesImportWizardEpic,
    fetchRecommendationsGridDataEpic,
    fetchRecommendationsScreenDataEpic,
    fetchRecommendationsGridSummaryEpic,
    submitRecommendationCardEpic,
    getRecommendationApplyCardStatusEpic,
    updateMinusPhraseListDataEpic,
    submitRecommendationsGridDataItemEpic,
    submitRecommendationsGridSummaryEpic,
    getRecommendationsGridSummaryApplyStatusEpic,
    getRecommendationsGridItemApplyStatusEpic,
    fetchReportsDataEpic,
    fetchReportsDomainDataEpic,
    addReportEpic,
    addReportDomainEpic,
    commonDataEpic,
    requestAuthorizationData,
    acceptPricesWizardChanges,
    requestClientMobileAppsDataEpic,
    fetchMobileAppsListEpic,
    submitStartPhraseInputValueEpic,
    getPhrasesStatsEpic,
    getPhraseStatsEpic,
    generatePhrasesEpic,
    manualInputSubmitEpic,
    updatePhrasesStatsEpic,
    savePhrasesEpic,
    openPhrasesSelectorEpic,
    leavePhrasesSelectorEpic,
    getGroupKeywordsEpic,
    getRefineWords,
    getRefinePhraseShowsEpic,
    changeRefinePhraseEpic,
    sendMinusPhraseEpic,
    removeMinusPhraseEpic,
    submitSelectionWizardEpic,
    addPhraseToStartPhrasesEpic,
    openPhrasesSelectorWizardEpic,
    fetchPhrasesForPhrasesSelectorWizardEpic,
    fetchMobileAppStoreInfoEpic,
    createMobileAppEpic,
    fetchMobileAppEpic,
    redirectToLocationEpic,
    requestClientFreelancerDataEpic,
    freelancers,
    updateDealsSourceParamsEpic,
    dealDetailEpic,
    updateDealsEpic,
    loadDealsCampaignsEpic,
    clientsDealsLoadEpic,
    acceptRejectDealsEpic,
    requestDealsEpic,
    resetDealsDataEpic,
    updateDocumentTitleEpic,
    changeLocationHardDataEpic,
    fetchCampaignAndGroupSelectorCampaignsDataEpic,
    fetchCampaignAndGroupSelectorGroupsDataEpic,
    acceptCampaignAndGroupSelectorDataEpic,
    openCampaignAndGroupSelectorEpic,
    selectCampaignAndGroupSelectorCampaignEpic,
    fetchAppTrackersTemplatesEpic,
    sendFeedbackEpic,
    updateMobileAppEpic,
    rejectRequestAuthorizationDataEpic,
    deleteCookieEpic,
    setCookieEpic,
    reloadLocationEpic,
    doFakeAuthEpic,
    switchShowCaptchaStateEpic,
    switchDumpVarsStateEpic,
    routerLocationChangedEpic,
    groupsEditEpic,
    clearInternalBannerEpic,
    duplicateInternalBannerEpic,
    openInternalBannersEditEpic,
    saveInternalBannersEpic,
    scrollToDuplicateInternalBannerEpic,
    scrollToNewInternalBannerEpic,
    saveInternalBannerNameEditorChangesEpic,
    updateInternalBannerTemplateIdEpic,
    openImageInternalGalleryEpic,
    removeInternalBannerImageEpic,
    updateInternalBannerImageByGalleryEpic,
    uploadInternalBannerImageByLinkEpic,
    uploadInternalBannerImageEpic,
    organizationsEpics,
    fetchInfoBlockDataEpic,
    fetchInfoBlockNewsItemEpic,
    fetchUserAccountsInfoEpic,
    fetchHeaderInfoEpic,
    fetchHeaderWalletInfoEpic,
    regionFetchSuggestListEpic,
    updatePhraseEpic,
    updateCampaignDayBudgetEpic,
    gridScreenHelpersEpic,
    gridScreenNavigationEpic,
    AddCalloutsEpic,
    RemoveCalloutsEpic,
    dealsNavigationEpic,
    dealsHelpersEpic,
    logNavigationEpic,
    logHelpers,
    recommendationsGridHelpersEpic,
    reportHelpersEpic,
    reportDomainHelpersEpic,
    startChangeFilterTextRegionsEditorEpic,
    deleteRetargetingListItemEpic,
    fetchLibraryListsEpic,
    addLibraryListEditorEpic,
    openMinusPhraseLibraryAddListModalEpic,
    createMinusPhraseListDataEpic,
    requestMinusPhraseLibraryGridRowEpic,
    handleMinusPhraseLibraryColumnsWidthUpdateEpic,
    resetMinusPhraseLibraryEpic,
    deleteMinusPhraseListEpic,
    openMinusPhraseLibraryEditListModalEpic,
    acceptCampaignAndGroupSelectorDataDnaEpic,
    openRetargetingConditionEditorEpic,
    editRetargetingListItemEpic,
    changeVisitorForecastDataEpic,
    saveRetargetingConditionDataEpic,
    updateRetargetingConditionEpic,
    saveRetargetingConditionAsNewDataEpic,
    saveAudienceRetargetingConditionAsNewDataEpic,
    hideRecommendationTooltipEpic,
    columnsSettingsEditorEpic,
    updateGridBannerPriceCellEpic,
    validateBannersPricesEpic,
    saveBannersPricesEpic,
    resetBannersPricesEpic,
    addRetargetingConditionEpic,
    addSmartFilterEpic,
    deleteSmartFilterEpic,
    updateSmartFilterEpic,
    updateSmartFilterSuccessEpic,
    saveFeedFiltersAutobudgetPriorityEpic,
    saveFeedFiltersRateEpic,
    saveFeedFilterRateCellEpic,
    saveFeedFilterPriorityCellEpic,
    setInitialFeedFilterRateEpic,
    setInitialFeedFilterPriorityEpic,
    getGroupFiltersEpic,
    openImageSmartCenterEditorEpic,
    updateImagesSmartCentresEpic,
    saveImageSmartCentersEpic,
    changeGoalsCheckedFromColumnsSettingsEditorEpic,
    fetchGoalsDataEpic,
    fetchDuplicateGroupsCampaignSelectorDataItemsEpic,
    changeDuplicateGroupsModalViewStateEpic,
    acceptDuplicateGroupsItemsEpic,
    openColumnsSettingsEditorEpic,
    fetchClientDev,
    onGridSourceParamsChangedEpic,
    onAcceptMassActionSiteLinksDataEpic,
    onAcceptMassActionsLinkBulkReplacementEditorEpic,
    onAcceptMassActionsLinkBulkPathReplacementEditorEpic,
    onAcceptMassActionsVideoEditorEpic,
    campaignsEditEpic,
    onAcceptMassActionsImageEditorEpic,
    copyRetargetingRulesInfoToClipboardEpic,
    changeCopiedRetargetingRulesTooltipStatusEpic,
    acceptMassCommonPriceChangesEpic,
    onAcceptMassActionsCalloutsEditorEpic,
    onAcceptMinusPhraseGroupsMassActionsEpic,
    chatListEditorEpic,
    metrikaCounterEditorEpic,
    onSaveMassActionsTextBulkReplacementEditorEpic,
    updateRetargetingCommonPriceCellEpic,
    onAcceptMassActionsLinkDisplayedBulkReplacementEditorEpic,
    loadInternalProductsEpic,
    createInternalProductEpic,
    updateInternalProductDescriptionEpic,
    loadInternalMarketersEpic,
    filterInternalMarketersEpic,
    loadInternalMarketerEpic,
    updateInternalMarketerProductAccessEpic,
    addInternalMarketerProductAccessEpic,
    removeInternalMarketerProductAccessEpic,
    fetchPredictorEpic,
    fetchPredictorRecommendationEpic,
    logEpics,
    openEditorMinusPhraseLibraryEpic,
    openTimeTargetingEditorEpic,
    onDeleteEndDateForDatesIntervalEditorEpic,
    fetchPredictorEditor,
    initialPredictorOutdoorEditor,
    initialPredictorIndoorEditor,
    fetchPredictorMapEpic,
    startAddEntityFromMenuEpic,
    loadMobileInstalledAppsDataEpic,
    saveInternalGroupsEpic,
    fetchTimeZoneGroupsEpic,
    visitingCardEditorEpic,
    keywordsEditorEpic,
    requestPricePackagesEpic,
    resetPricePackagesDataEpic,
    updatePricePackagesSourceParamsEpic,
    pricePackagesHelpersEpic,
    pricePackagesNavigationEpic,
    fetchMobileAppTemplatesEpic,
    pricePackagesEditEpic,
    html5Epics,
    canvasEpics,
    loadBannersPreviewEpic,
    saveStatusPricePackageEpic,
    gridScreenMassActionsEpic,
    gridScreenGoToPackageEditEpic,
    leavePricePackageEditEpic,
    fetchTopRegionsForRegionsTransformEditorEpic,
    openRegionsTransformEditorEpic,
    changeSearchValueForRegionsSearchEditorEpic,
    clearRegionsTransformEditorEpic,
    applyRegionsTransformEditorEpic,
    showNotificationRegionsTransformEditorEpic,
    userSettingsEpic,
    openPricePackagesClientsModalEpic,
    savePricePackagesClientsModalEpic,
    videoCreatorEpics
];

export const mainEpic = combineEpics(...epics);
